/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ContentPage, type ContentType } from '$comp/lessons/sidebar/LessonSidebarTypes';

export const iconNameForContentType = (contentType: ContentType) => {
	if (contentType === 'Reflection') return 'SquarePen'
	else if (contentType === 'Mission') return 'Map'
	else if (contentType === 'Lesson') return 'PlayLucide'
	else if (contentType === 'Discussion') return 'MessagesSquare'
	else if (contentType === 'Reading') return 'BookOpen'
	else return 'PlayLucide'
}

export const sidebarCardClass = (cardLesson: ContentPage, currentLessonId: string | number) => {
	if (cardLesson.id == currentLessonId) {
		return 'sidebar__card sidebar__card--current';
	}
	else if (cardLesson.completed) {
		return 'sidebar__card sidebar__card--complete';
	}
	else {
		return 'sidebar__card';
	}
}

export const eyebrowForContentType = (
  contentPage: ContentPage & { type_overlay?: string; url?: string },
  translations: any
) => {
  const overlay = contentPage?.type_overlay?.toString().trim();
  const contentType = contentPage?.content_type;
  const url = contentPage?.url?.toString() || '';
  const isExternalLink = /\/external_links\//.test(url);

  if (overlay) {
    return overlay;
  }

  if (!translations) {
    const output = contentType || 'Link';
    return output;
  }
  if (!contentType) {
    return 'Link';
  }

  switch (contentType) {
    case 'Video':
    case 'Lesson': {
      const output = isExternalLink ? 'Video' : (translations?.lesson || 'Video Lesson');
      return output;
    }
    case 'LearningPath': {
      const output = (contentPage as any).is_expert_class
        ? translations?.expert_class
        : translations?.learning_path;
      return output;
    }
    case 'Course Module': {
      const output = translations?.course_module;
      return output;
    }
    case 'Survey/Poll': {
      const output = translations?.survey_poll;
      return output;
    }
  }

  const key = contentType.toLowerCase();
  const output = Object.prototype.hasOwnProperty.call(translations || {}, key)
    ? translations[key]
    : contentType;

  return output;
};
